import { render, staticRenderFns } from "./VacationCard.vue?vue&type=template&id=c29bc9b2&scoped=true"
import script from "./VacationCard.vue?vue&type=script&lang=js"
export * from "./VacationCard.vue?vue&type=script&lang=js"
import style0 from "./VacationCard.vue?vue&type=style&index=0&id=c29bc9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29bc9b2",
  null
  
)

export default component.exports